export default (input) => {
  let val = (input / 1).toFixed(0).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}



// WEBPACK FOOTER //
// ./src/filter/filter-currency.js